<template>
  <div class="row" v-if="showAnnouncer">
    <div class="col" >
      <div v-if="announcers.length > 0" v-for="item in announcers" class="locutor">
        <img :src="item.imagem">
        <span>{{ item.name }}</span>
          <a v-if="item.site" :href="item.site" target="_blank" class="url">({{item.site}} <i class="fas fa-external-link-alt"></i>)</a>
        <p> {{ item.sobre_hotsite  }}</p>

        <div class="redes_sociais">
          <a v-if="item.facebook" :href="item.facebook" target="_blank"><i class="fab fa-facebook-f"></i></a>
          <a v-if="item.google" :href="item.google" target="_blank"><i class="fab fa-google-plus-g"></i></a>
          <a v-if="item.twitter" :href="item.twitter" target="_blank"><i class="fab fa-twitter"></i></a>
          <a v-if="item.instagram" :href="item.instagram" target="_blank"><i class="fab fa-instagram"></i></a>
          <a v-if="item.whatsapp" :href="item.whatsapp" target="_blank"><i class="fab fab fa-whatsapp"></i></a>
          <a v-if="item.youtube" :href="item.youtube" target="_blank"><i class="fab fab fa-youtube"></i></a>
        </div>
      </div>
      <p v-if="announcers.length <= 0"> Sem locutores</p>
    </div>
  </div>
</template>

<script>
  import services from "../service/api";

  export default {
    props:[],
    name: "Announcer",
    data(){
      return {
        announcers:{},
        showAnnouncer:window.config.site.announcer
      }
    },
    mounted(){
    },
    created(){
      let self = this;
      if(self.showAnnouncer){
        services.getAnnouncers().then(function (response) {
          self.announcers = response.data;
          self.showAnnouncers = true;
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Announcer.vue